import React from 'react'
import { Link, useParams } from 'react-router-dom'

import { ScreenSpin } from 'admin/lib/ScreenSpin'
import { Queries } from 'admin/lib/Api'
import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import * as ROUTES from 'admin/routes'
import { BIReportEditForm } from './BIReportEditForm'

export function BIReportEdit() {
  const { accountId } = useParams()
  const accounts = Queries.useAccounts({ scope: 'global' })
  const biReports = Queries.useBIReports()
  const users = Queries.useUsers()
  return (
    <Layout
      header={
        <Breadcrumb
          items={[
            {
              title: (
                <BreadcrumbArrayItem>
                  <Link to={ROUTES.BI_REPORTS.INDEX}>BI Reports</Link>
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem loading={accounts.isLoading}>
                  {accounts.data?.find(acc => acc.accountId === accountId).name}
                </BreadcrumbArrayItem>
              )
            }
          ]}
        />
      }
    >
      {(!biReports.isFetched || !users.isFetched) && <ScreenSpin />}

      {biReports.isError && <div>{String(biReports.error)}</div>}
      {users.isError && <div>{String(users.error)}</div>}

      {biReports.isFetched && accounts.isFetched && users.isFetched && (
        <BIReportEditForm
          account={accounts.data?.find(acc => acc.accountId === accountId)}
          biReports={biReports.data?.filter(rep => rep.accountId === accountId)}
          users={users.data}
        />
      )}
    </Layout>
  )
}
